import React from 'react';

const MenuArrowIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 8" fill="none">
      <path d="M4 6 .54 0h6.92L4 6Z" fill="#A1AFC5" />
    </svg>
  );
};

export default MenuArrowIcon;
